import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

export class CouponExplain extends Component {
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div className="center-coupon-explain">
        <div className='explain_item'>
          <div className='explain_title'>1. 优惠券的获取</div>
          <div className='explain_content'>通过活动赠送，手动领取，可在优惠券卡包查看</div>
        </div>
        <div className='explain_item'>
          <div className='explain_title'>2. 优惠券的使用</div>
          <div className='explain_content'>（1）单笔订单只能使用1张优惠券, 不支持同时使用多张；</div>
          <div className='explain_content'>（2）优惠券可以在订单结算的时候抵扣相应金额，但不能直接兑换现金。</div>
          <div className='explain_content'>（3）部分商品无法使用优惠券，敬请谅解。</div>
          <div className='explain_content'>（4）每张优惠券的使用条件请查看对应优惠券的使用说明；</div>
          <div className='explain_content'>（5）优惠券仅限于网校展示的对象商品使用，并且仅在网站订购时使用；</div>
          <div className='explain_content'>（6）优惠券不适用于课程包阶段购买；</div>
          <div className='explain_content'>（7）如发生系统问题，优惠券使用规则以客服工作人员确认为准；</div>
        </div>
        <div className='explain_item'>
          <div className='explain_title'>3. 优惠券失效</div>
          <div className='explain_content'>（1）使用优惠券的订单, 若产生退货, 优惠券均不退回, 退款金额按优惠后的小计金额退款；</div>
          <div className='explain_content'>（2）请在有效期内使用优惠券, 未使用的优惠券过期后, 将自动作废；</div>
          <div className='explain_content'>（3）优惠券严禁出售或转让, 如经证实, 该券将予以失效处理；</div>
        </div>
        <div className='explain_tips'>如需了解更多, 请联系在线客服或拨打客服电话：李老师 - 183-7318-9564</div>
        <div className='explain_tips'>本公司在法律范围内保留对优惠券使用细则的最终解释权</div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CouponExplain);



// WEBPACK FOOTER //
// ./src/features/center/CouponExplain.js